import script from "./SimpleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleModal.vue?vue&type=script&setup=true&lang=js"

import "./SimpleModal.vue?vue&type=style&index=0&id=5a0fe9fa&scoped=true&lang=css"

import exportComponent from "D:\\agents\\Oreo\\_work\\93\\s\\NcasReporting\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a0fe9fa"]])

export default __exports__